<div class="modal-header">
  
  <h4 md-dialog-title class="modal-title pull-left"><span><mat-icon class="red-icon">error</mat-icon> {{data.header}}</span></h4>
</div>
<div class="modal-body">
  <mat-dialog-content>
    <div *ngIf="data.aulProfile.length > 0">
      <span>Url :  {{data?.errorMessage?.url}}</span> <br/>
      <span>Error Status : {{data?.errorMessage?.status}}</span><br/>
      <span>Error Message : {{data?.errorMessage?.error.Message != '' ? data?.errorMessage.error?.Message: data?.errorMessage.message }}</span><br/>
      <span>Unhandled Error Message : {{data?.errorMessage.message }}</span><br/>
      <span>Profile Details :</span><br/>
      <ul>
          <li *ngFor="let item of data.aulProfile">{{item}}</li>
      </ul>
    </div>
    <div *ngIf="data?.pipeLineError?.IsError">
      <span>Error Message : {{data.pipeLineError.Message}}</span><br/>
    </div>
  </mat-dialog-content>
</div>
<div class="modal-footer">
  <mat-dialog-actions>
    <div class="btn-container">
      <button class="btn btn-secondary" md-raised-button (click)="onClose('Close')">
       Close
      </button>
    </div>
  </mat-dialog-actions>
</div>